
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { Component, Injector, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, RouterOutlet, NavigationStart } from '@angular/router';
import { NgModule } from '@angular/core';
// import { COMMON_MODULES } from '@app/core/constants/common-module.constant';
import { CoreClass } from '@src/app/core/base/core.class';
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { HeaderDisclaimerBannerComponent } from '@src/app/core/shared/components/header-disclaimer-banner/header-disclaimer-banner.component';
import { filter, Subscription, tap } from 'rxjs';
import { LocalStorageService, SharedDataService } from '@src/app/core/services';
import { ABOUT_US, ACA_CONTENT, ACAWELLNESS, CONTACT_US, DENTAL, HEALTH_SHARING, HEALTHSHARE_SERVICE, IMAGES_URL, IMAGING, LAB_TEST, MENTAL_HEALTH_COUNSELING, OFFICE_VISIT, PLUS_MEMBERSHIP, PROFILE, PUBLIC_ROUTES, RESOURCES, ROUTES, SSO, SURGICAL, VIRTUAL_URGENT_CARE, VISION_SERVICE } from '@src/app/core/constants';
import { StorageService } from '@src/app/core/services/storage.service';
import { MemberPortalNavbarComponent } from '../../member-portal/navbar/navbar.component';
import { Console } from 'console';
import { ModalService } from '@src/app/core/services/modal.service';
import { CobrandingBannerComponent } from "@src/app/core/shared/components/cobranding-banner/cobranding-banner.component";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { Observable } from 'rxjs';
import { AppModeState } from '@src/app/core/ngxs/actions/app-mode.state';
import { Store } from '@ngxs/store';
import { MiniEnvNavbarComponent } from '../../mini-env/navbar/navbar.component';
import { ChangeDetectorRef } from '@angular/core';
import { MiniEnvFooterComponent } from "../../mini-env/footer/footer.component";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from '@src/environments/environment';
import { ErrorDialogComponent } from '@src/app/core/shared/components/error-dialog/error-dialog.component';
import { ErrorDialogService } from '@src/app/core/services/error-dialog.service';
@Component({
  selector: 'app-layout-base',
  standalone: true,
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  imports: [
    // ...COMMON_MODULES,
    CommonModule,
    RouterOutlet,
    HeaderDisclaimerBannerComponent,
    NavbarComponent,
    FooterComponent,
    MemberPortalNavbarComponent,
    MiniEnvNavbarComponent,
    NgxUiLoaderModule,
    CobrandingBannerComponent,
    MiniEnvFooterComponent,
    ErrorDialogComponent
  ],
})
export class BaseComponent implements OnInit {
  isLoading: boolean | any;
  isnavbar = false;
  environment = environment;
  public isBrowser: boolean = false;
  private readonly platformId: any;
  private route = inject(Router)
  private localStorageService = inject(LocalStorageService)
  public sharedDataService = inject(SharedDataService);
  public No_Footer_Routes = ['profile', 'payment', 'presell-page', 'wow-plus-info'];
  public No_Navbar_Routes = ['presell-page', 'healthcare-ad'];
  public Allow_MemberPortal_Header = [RESOURCES];
  public showNavbar = true;
  public topbarType = "WEBSITE";
  public SSO = SSO
  isNavbarOpen = false;
  isMemberPortalOnly = environment.memberPortalOnly
  isCobranded: boolean = false;
  isMiniEnv$: boolean = false;
  hasWellnessMembership: boolean = false;
  includedurls = [
    ACA_CONTENT
  ];
  publicRouteList = PUBLIC_ROUTES;
  @ViewChild(ErrorDialogComponent) modalComponent!: ErrorDialogComponent;
  private subscription!: Subscription;

  constructor(
    injector: Injector,
    private router: Router,
    private storageService: StorageService,
    private store: Store,
    private modalService: ModalService,
    private cd: ChangeDetectorRef,
    private ngxService: NgxUiLoaderService,
    private errorService: ErrorDialogService
  ) {

    this.platformId = injector.get(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(this.platformId);
    // Spinner for lazyload modules — routed through the shared loader so the
    // lazy-chunk spinner uses the SAME task as page data requests. This keeps the
    // loader continuous from chunk-download into the page's first data load (its
    // debounce bridges the gap), fixing the "no loader on a route's first open".
    // The RouteConfigLoadStart/End pair is self-balancing, so no catch-all stop.
    router.events.forEach(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.sharedDataService.showLoader();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.sharedDataService.hideLoader();
      }
    });

  }
  loaderColor = getComputedStyle(document.documentElement)
  .getPropertyValue('--primary-color')
  .trim();
  ngOnInit(): void {
    const landingPage = this.store.selectSnapshot(AppModeState.envConfig)?.landingPage;
    const additionalPath = this.store.selectSnapshot(AppModeState.envConfig)?.additionalPath;
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    if (this.router.url === '/') {
      this.router.navigate([(landingPage || "") + "/" + (additionalPath || "")]);
    }

    this.topbarType = this.localStorageService.getDataInLocalStorage('topbar');
    this.route.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(
      (event: any) => {
        if (landingPage && event.url === '/') {
          this.router.navigate([landingPage]);
        }
        this.footerCheck(event.url);
        this.navbarCheck(event.url);
        this.modalService.closeAll();
      }
    )
    this.footerCheck()
    this.navbarCheck();
    this.isMiniEnv$ = this.store.snapshot().appMode.isMiniEnv; 
    this.subscription = this.errorService.error$.subscribe(dialogData => { 
      this.openErrorDialog(dialogData);
    });
  }
  footerCheck(url?: any) {
    const urlPath = url ? url : this.route.url
    if (this.storageService.getUserInformation() && this.No_Footer_Routes.some(route => urlPath.includes(route))) {
      this.sharedDataService.user.update(() => true)
    }
    else {
      this.sharedDataService.user.update(() => false)
    }
  }

  navbarCheck(url?: string) {
    const urlPath = url ? url : this.route.url
    this.showNavbar = !this.No_Navbar_Routes.some(route => urlPath.includes(route));
    this.setTopbarType(url);
  }
  setTopbarType(url?: string) {
    const urlPath = url ? url : this.route.url
    // const showWebsiteTopbar = !this.Allow_MemberPortal_Header.some(route => urlPath.includes(route));
    // const showWebsiteTopbar = this.publicRouteList.includes(urlPath); // Only show website topbar on public routes
    const showWebsiteTopbar = this.publicRouteList.includes(urlPath); // Only show website topbar on home
    if (showWebsiteTopbar) {
      this.localStorageService.setDataInLocalStorage({ key: 'topbar', value: '"WEBSITE"' });
      this.topbarType = "WEBSITE";
    }
  }

  onnavbarChange(status: boolean) {
    this.isNavbarOpen = status;
  }
  includedURL() {
    const currentUrl = this.router.url
    let status = false
    for (let url of this.includedurls) {
      if (currentUrl.includes(url)) {
        status = true
        break;
      }
    }
    return status
  }
  private openErrorDialog(dialogData: any = null) {    
    if (!this.modalComponent) {
      console.error('Modal component not found');
      return;
    }
    let image = IMAGES_URL + 'handle-errors-icon.svg';
    if(dialogData?.image)
    {
      image = dialogData?.image;
    }
    let mainClass = 'dashboard-error-msg';
    if(dialogData?.mainClass)
    {
      mainClass = dialogData?.mainClass;
    }
    let title = 'System error';
    if(dialogData?.title)
    {
      title = dialogData?.title;
    }
    let message = 'Please try again.';
    if(dialogData?.message)
    {
      message = dialogData?.message;
    }
    let btnText = 'Back';
    if(dialogData?.btnText)
    {
      btnText = dialogData?.btnText;
    }
    let imageWidth = 128;
    if(dialogData?.imageWidth)
    {
      imageWidth = dialogData?.imageWidth;
    }
    let imageHeight = 128;
    if(dialogData?.imageHeight)
    {
      imageHeight = dialogData?.imageHeight;
    }

    this.modalComponent.IMAGES_URL = image;
    this.modalComponent.mainClass = mainClass;
    this.modalComponent.title = title;
    this.modalComponent.message = message;
    this.modalComponent.btnText = btnText;
    this.modalComponent.imageWidth = imageWidth;
    this.modalComponent.imageHeight = imageHeight;
    this.modalComponent.open();
  }
  
  modalClose() { 
    if(this.topbarType == 'MEMBERPORTAL'){
      setTimeout(() => {
        // this.router.navigate([ROUTES.dashboard]);
      }, 500);
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
